export default "__VITE_ASSET__CQZPc2pS__"